import clsx from 'clsx';

import styles from './overlay.module.scss';

interface OverlayUIProps {
  children?: React.ReactNode;
  background?: 'dark' | 'white';
  'data-testid'?: string;
  id?: string;
  isFullScreen?: boolean;
}

export const OverlayUI: React.FC<OverlayUIProps> = ({
  children,
  background = 'dark',
  'data-testid': dataTestId,
  id,
  isFullScreen,
}) => {
  return (
    <div
      className={clsx(
        styles.overlay,
        styles[background],
        isFullScreen && styles.fullScreen
      )}
      data-testid={dataTestId}
      id={id}
    >
      {children}
    </div>
  );
};
